import { render } from "./ProfileProgressBar.vue?vue&type=template&id=54c0ab78&scoped=true"
import script from "./ProfileProgressBar.vue?vue&type=script&lang=js"
export * from "./ProfileProgressBar.vue?vue&type=script&lang=js"

import "./ProfileProgressBar.vue?vue&type=style&index=0&id=54c0ab78&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c0ab78"]])

export default __exports__